/**
 * The Agency Hub's way into a session's room (Session: "Broker and Staff are
 * sent into the policyholder portal").
 *
 * Staff never go to the policyholder portal to run a session. The room is
 * hosted inside the hub (HubSessionRoom, in the hub shell) and opens over the
 * page they are on: the URL stays in the hub, and closing the room leaves
 * them exactly where they were — the same Sessions tab, filter and scroll.
 *
 * The host registers how it opens a room; a page asks through openHubRoom,
 * which waits for the host if the socket is still connecting.
 */
let opener = null;
let waiting = [];

export function registerHubRoom(open) {
  opener = open;
  const queued = waiting;
  waiting = [];
  queued.forEach(({ sessionId, resolve, reject }) => open(sessionId).then(resolve, reject));

  return () => {
    if (opener === open) opener = null;
  };
}

/** Open a session's room over the current hub page. Resolves once it is opening. */
export function openHubRoom(sessionId) {
  if (opener) return opener(sessionId);

  return new Promise((resolve, reject) => {
    waiting.push({ sessionId, resolve, reject });
  });
}
